import React, { useState } from "react";
import { Row, Modal, Form } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { FormContext } from "../../reusable_components/input_fields/FormContext";
import Element, { FieldProps } from "../../reusable_components/input_fields/Input";

import alertModalStyles from "../../../Reusables/components/AlertModal/AlertModal.module.css";
import styles from "./WetSignUploadModal.module.css";

import { handleChange } from "./WetSignUploadModal.utils";
import { submitWetSignDocument } from "./WetSignUploadModal.service";

import { WetSignUploadModalProps } from "./WetSignUploadModal.types";
import CustomButton from "../../reusable_components/custom_button_component/Button";


const WetSignUploadModal: React.FC<WetSignUploadModalProps> = ({
    show,
    onHide,
    elData,
    refresh
}) => {
    const [uploading, setUploading] = useState<boolean>(false);
    const [elements, setElements] = useState<FieldProps[]>([
        {
            id: uuidv4(),
            label: null,
            mandatory: true,
            approval: false,
            disabled: false,
            placeholder: "Upload signed EL (.pdf)",
            type: "file",
            example: null,
            pivot: true,
            pivotreverse: false,
            value: "",
            width: 12,
            fileTypes: ".pdf"
        },
    ]);

    const onSubmit = async() => {
        if (!elements[0].value) return;
        
        await submitWetSignDocument(
            elData?.ProcessedTemplateId,
            elData?.ClientMasterId,
            elData?.ClientId,
            elData?.ClientName,
            elData?.FileName,
            elements[0].value,
            setUploading,
            refresh,
            onHide
        );
    };

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                centered
                keyboard={false}
                dialogClassName={alertModalStyles.dialog}
                contentClassName={alertModalStyles.content}
                backdropClassName={alertModalStyles.backdrop}
                aria-labelledby="wetsign-upload-modal"
            >
                <Modal.Header closeButton className={alertModalStyles.header}>
                    <div className={styles.wetSignHeaderContainer}>
                        <div className={styles.wetSignHeaderTopRow}>
                            <Modal.Title
                                className={`${alertModalStyles.message} ${styles.wetSignTitle}`}
                            >
                                Upload WetSigned EL
                            </Modal.Title>
                        </div>
                        <span className={styles.wetSignClient}>
                            (<strong>{elData?.ClientId} – {elData?.ClientName}</strong>)
                        </span>
                    </div>
                </Modal.Header>

                <Modal.Body className={alertModalStyles.body}>
                    <FormContext.Provider
                        value={{
                            handleChange: (field_id, event) =>
                                handleChange(elements, setElements, field_id, event),
                        }}
                    >
                        <Form>
                            <Row>
                                <label
                                    className={`${alertModalStyles.message} ${styles.label}`}
                                >
                                    Upload Signed PDF
                                </label>

                                {elements.map((field, i) => (
                                    <Element key={i} field={field} md={12} />
                                ))}
                                {elements[0].value && (
                                    <div className={styles.filePreviewContainer}>
                                        <div className={styles.filePreview}>
                                        <div className={styles.fileLeft}>
                                            <span className={styles.fileIcon}>📄</span>
                                            <span className={styles.fileName}>{elements[0].value.name}</span>
                                        </div>

                                        <span
                                            className={styles.removeIcon}
                                            onClick={() =>
                                            setElements(prev => [{ ...prev[0], value: "" }])
                                            }
                                        >
                                            ✖
                                        </span>
                                        </div>
                                    </div>
                                )}
                            </Row>
                        </Form>
                    </FormContext.Provider>
                </Modal.Body>

                <Modal.Footer className={alertModalStyles.footer}>
                    <CustomButton 
                        onclick={onHide} 
                        content="Cancel" 
                        type="quinary"
                    />
                    <CustomButton
                        progress={uploading}
                        onclick={onSubmit}
                        content="Submit"
                        disabled={!elements[0].value}
                        type="tertiary"
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default WetSignUploadModal;
